import React, { ReactNode } from "react";
import { Button, Modal, Form } from "react-bootstrap";

type SaveDynamicModelModalProps = {
    show: boolean,
    modelName: string,
    isEdit: boolean,
    onClose: () => void,
    onSave: () => void,
    onNameChange: (name: string) => void
}

export default class SaveDynamicModelModal extends React.Component<SaveDynamicModelModalProps> {
    
    private handleSave = (): void => {
        if (this.props.modelName.trim()) {
            this.props.onSave();
        }
    };

    private handleKeyPress = (event: React.KeyboardEvent): void => {
        if (event.key === "Enter" && this.props.modelName.trim()) {
            this.handleSave();
        }
    };

    public render(): ReactNode {
        const isValid = this.props.modelName.trim().length > 0;
        const title = this.props.isEdit ? "Save Dynamic Model" : "Create Dynamic Model";
        const buttonText = this.props.isEdit ? "Save Changes" : "Create Model";

        return (
            <Modal show={this.props.show} onHide={this.props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Model Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter model name"
                                value={this.props.modelName}
                                onChange={(e) => this.props.onNameChange(e.target.value)}
                                onKeyPress={this.handleKeyPress}
                                isInvalid={!isValid && this.props.modelName.length > 0}
                                autoFocus
                            />
                            <Form.Control.Feedback type="invalid">
                                Model name cannot be empty
                            </Form.Control.Feedback>
                            <Form.Text className="text">
                                This name will be used to identify your model in the Model Manager.
                            </Form.Text>
                        </Form.Group>
                    </Form>
                    {this.props.isEdit && (
                        <div className="mt-3">
                            <small className="text">
                                <b>Note:</b> Saving will update the existing model configuration, but it may take up to 10 minutes for the changes to propagate and for the changes to take effect in recommendations.
                            </small>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.props.onClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={this.handleSave}
                        disabled={!isValid}
                    >
                        {buttonText}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

